import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar, Thumbs } from 'swiper';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postCaseItem, postVideoItem, postSlideItem, postNewsItem, CMS_BASE_URL } from '../../redux/action';

import 'swiper/css/navigation';
import 'swiper/css';
import './post.css'; 
import '../common/common.css'; 

import csBanner from '../../images/csBanner.png';
import slideBanner from '../../images/slideBanner.png';
import videoBanner from '../../images/videoBanner.png';
import newsBanner from '../../images/newsBanner.png';
import videoBtn from '../../images/videoBtn.png';

class PostDetail extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "",
	    	banner: "",
	    	item: {},
	    	thumbsSwiper: null
	    };
    }


  componentDidMount() {
  	

		const splits = window.location.href.split('/');


  	switch (this.props.postType) {
			case "case":
				postCaseItem({ "post_id": splits[splits.length - 1] }).then(res => {
					this.setState({ 
						title: "Case Sharing",
						banner: csBanner,
						item: res.data
					})
				}, this)
				break;

			case "video":
				postVideoItem({ "post_id": splits[splits.length - 1] }).then(res => {
					this.setState({ 
						title: "Past Conference Video",
						banner: videoBanner,
						item: res.data
					})
				}, this)
				break;

			case "slide":
				postSlideItem({ "post_id": splits[splits.length - 1] }).then(res => {
					this.setState({ 
						title: "Slide Decks",
						banner: slideBanner,
						item: res.data
					})
				}, this)
				break;

			case "news":
				postNewsItem({ "post_id": splits[splits.length - 1] }).then(res => {
					this.setState({ 
						title: "News and Updates",
						banner: newsBanner,
						item: res.data
					})
				}, this)
				break;

			default:
				break;
		}
  }

	componentWillMount() {

		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}
		// switch (this.props.postType) {
		// 	case "case":
		// 		this.setState({
		// 			title: "Case Sharing",
		// 			banner: csBanner,
		// 			item: {
		// 					id: 1,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "Case Sharing 1",
		// 					desc: "Breast cancer is the most diagnosed cancer among women worldwide, accounting for 1 in 4 cancer cases. It is the most frequent cancer amongst both sexes and is the leading cause of death from cancer in women. The estimated 2.3 million new cases indicate that one in every 8 cancers diagnosed in 2020 is breast cancer. In 2020, there were an estimated 684,996 deaths from breast cancer, with a disproportionate number of these deaths occurring in low-resource settings.<br/><br/>Breast cancer cells usually form a tumour that can often be seen on an x-ray or felt as a lump. If spread outside the breast through blood vessels and lymph vessels, it becomes advanced breast cancer. When breast cancer spreads to other parts of the body (such as the liver, lungs, bones or brain), it is said to have metastasised, and is referred to as metastatic breast cancer.<br/><br/>Survival rates for breast cancer are very high when the cancer is detected early and where treatment is available. Unfortunately, 50 to 80% of breast cancer cases are diagnosed at an advanced stage in many low- and middle-income countries, when the cancer is more difficult to treat, is more expensive to do so, and is usually incurable.<br/><br/>To tackle the growing breast cancer burden, it is critical that improvements are made in access to early detection, timely access to treatment and care, palliative and survivorship care, and comprehensive data collection through robust cancer registries."
		// 				}
		// 		})
		// 		break;

		// 	case "video":
		// 		this.setState({
		// 			title: "Past Conference Video",
		// 			banner: videoBanner,
		// 			item: {
		// 					id: 1,
		// 					source: "https://www.youtube.com/embed/HlpOXqtMMA0",
		// 					date: "1 May 2022",
		// 					title: "Conference Video 3",
		// 					desc: "Breast cancer is the most diagnosed cancer among women worldwide, accounting for 1 in 4 cancer cases. It is the most frequent cancer amongst both sexes and is the leading cause of death from cancer in women. The estimated 2.3 million new cases indicate that one in every 8 cancers diagnosed in 2020 is breast cancer. In 2020, there were an estimated 684,996 deaths from breast cancer, with a disproportionate number of these deaths occurring in low-resource settings.<br/><br/>Breast cancer cells usually form a tumour that can often be seen on an x-ray or felt as a lump. If spread outside the breast through blood vessels and lymph vessels, it becomes advanced breast cancer. When breast cancer spreads to other parts of the body (such as the liver, lungs, bones or brain), it is said to have metastasised, and is referred to as metastatic breast cancer.<br/><br/>Survival rates for breast cancer are very high when the cancer is detected early and where treatment is available. Unfortunately, 50 to 80% of breast cancer cases are diagnosed at an advanced stage in many low- and middle-income countries, when the cancer is more difficult to treat, is more expensive to do so, and is usually incurable.<br/><br/>To tackle the growing breast cancer burden, it is critical that improvements are made in access to early detection, timely access to treatment and care, palliative and survivorship care, and comprehensive data collection through robust cancer registries."
		// 				}
		// 		})
		// 		break;

		// 	case "slide":
		// 		this.setState({
		// 			title: "Slide Decks",
		// 			banner: slideBanner,
		// 			item: {
		// 					id: 1,
		// 					source: "https://www.youtube.com/embed/HlpOXqtMMA0",
		// 					images: [
		// 						"/images/news/news1.png","/images/news/news2.png","/images/news/news3.png","/images/news/news4.png"
		// 					],
		// 					date: "16 May 2022",
		// 					title: "Slide 01",
		// 					desc: "Breast cancer is the most diagnosed cancer among women worldwide, accounting for 1 in 4 cancer cases. It is the most frequent cancer amongst both sexes and is the leading cause of death from cancer in women. The estimated 2.3 million new cases indicate that one in every 8 cancers diagnosed in 2020 is breast cancer. In 2020, there were an estimated 684,996 deaths from breast cancer, with a disproportionate number of these deaths occurring in low-resource settings.<br/><br/>Breast cancer cells usually form a tumour that can often be seen on an x-ray or felt as a lump. If spread outside the breast through blood vessels and lymph vessels, it becomes advanced breast cancer. When breast cancer spreads to other parts of the body (such as the liver, lungs, bones or brain), it is said to have metastasised, and is referred to as metastatic breast cancer.<br/><br/>Survival rates for breast cancer are very high when the cancer is detected early and where treatment is available. Unfortunately, 50 to 80% of breast cancer cases are diagnosed at an advanced stage in many low- and middle-income countries, when the cancer is more difficult to treat, is more expensive to do so, and is usually incurable.<br/><br/>To tackle the growing breast cancer burden, it is critical that improvements are made in access to early detection, timely access to treatment and care, palliative and survivorship care, and comprehensive data collection through robust cancer registries."
		// 				}
		// 		})
		// 		break;

		// 	case "news":
		// 		this.setState({
		// 			title: "News and Updates",
		// 			banner: newsBanner,
		// 			item: {
		// 					id: 1,
		// 					thumb: "/images/news/news1.png",
		// 					date: "13 June 2022",
		// 					title: "News 1",
		// 					desc: "Breast cancer is the most diagnosed cancer among women worldwide, accounting for 1 in 4 cancer cases. It is the most frequent cancer amongst both sexes and is the leading cause of death from cancer in women. The estimated 2.3 million new cases indicate that one in every 8 cancers diagnosed in 2020 is breast cancer. In 2020, there were an estimated 684,996 deaths from breast cancer, with a disproportionate number of these deaths occurring in low-resource settings.<br/><br/>Breast cancer cells usually form a tumour that can often be seen on an x-ray or felt as a lump. If spread outside the breast through blood vessels and lymph vessels, it becomes advanced breast cancer. When breast cancer spreads to other parts of the body (such as the liver, lungs, bones or brain), it is said to have metastasised, and is referred to as metastatic breast cancer.<br/><br/>Survival rates for breast cancer are very high when the cancer is detected early and where treatment is available. Unfortunately, 50 to 80% of breast cancer cases are diagnosed at an advanced stage in many low- and middle-income countries, when the cancer is more difficult to treat, is more expensive to do so, and is usually incurable.<br/><br/>To tackle the growing breast cancer burden, it is critical that improvements are made in access to early detection, timely access to treatment and care, palliative and survivorship care, and comprehensive data collection through robust cancer registries."
		// 				}
		// 		})
		// 		break;

		// 	default:
		// 		break;
		// }
	}

	getFile(object) {
		if (object) {
			if (object.length > 2) {
				return JSON.parse(object)[0].download_link
			}
		}
		return ""
	}

	getSlides(object) {
		if (object) {
			if (object.length > 0) {
				console.log(JSON.parse(object));
				return JSON.parse(object)
			}
		}
		return []
	}

	renderFeatured() {
		switch (this.props.postType) {
			case "case":
				return (
					<img className="thumbnail" src={CMS_BASE_URL+"/storage/"+this.state.item.thumbnail} />
				);
			case "video":
				return (
					(this.state.item.video_source_link) ? (<iframe className="videoFrame" src={this.state.item.video_source_link}  frameborder="0" ></iframe>) : (
						<video className="videoFrame" controls src={CMS_BASE_URL+"/storage/"+this.getFile(this.state.item.video_source)} type="video/mp4"></video>
					)
				);
			case "slide":
				return (
					<div className="sliderFrame">
						{
							(this.state.thumbsSwiper) ? (
								<Swiper
								  spaceBetween={0}
							      slidesPerView={1}
							      modules={[Navigation, Scrollbar, Thumbs]}
							      navigation={{ clickable: true }}
							      onSlideChange={() => console.log('slide change')}
							      thumbs={{ swiper: this.state.thumbsSwiper }}
							      className="slideSwiper"
							    >
							    	{
							    		this.getSlides(this.state.item.slides).map((item, idx) => {
							    			return (
										      <SwiperSlide className="sliderItem">
										      	<img className="sliderThumb" src={CMS_BASE_URL+"/storage/"+item.download_link} />
										      </SwiperSlide>
						    				);
							    		})
							    	}
							    </Swiper>
							) : ""
						}
						
					    <Swiper
					      spaceBetween={10}
					      slidesPerView={4}
					      modules={[Scrollbar, Thumbs]}
					      scrollbar={{ draggable: true }}
					      onSlideChange={() => console.log('slide change')}
					      onSwiper={(swiper) => this.setState({ thumbsSwiper: swiper })}
					      watchSlidesVisibility={true}
					      watchSlidesProgress={true}
					    >
					    	{
					    		this.getSlides(this.state.item.slides).map((item, idx) => {
					    			return (
								      <SwiperSlide className="sliderItem">
								      	<img className="sliderThumb" src={CMS_BASE_URL+"/storage/"+item.download_link} />
								      </SwiperSlide>
				    				);
					    		})
					    	}
					    </Swiper>
					    {
					    	(this.state.item.file_download) ? (
							    <div className="downloadBtn">
							    	<div className="actionBtn">
								    	<a href={CMS_BASE_URL+"/storage/"+this.getFile(this.state.item.file_download)} target="_blank"><span>DOWNLOAD</span></a>
							    	</div>
							    </div>
					    	) : ""
					    }
					</div>
				);
			case "news":
				return (
					<img className="thumbnail" src={CMS_BASE_URL+"/storage/"+this.state.item.thumbnail} />
				);
			default:
				return "";
		}
	}


	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={this.state.banner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>{ this.state.title }</h2>
						</div>
						{
							(this.state.item) ? (
								<div className="bodyContent containerMaxWidth postDetailBox">
									<div className="detailSeparator">
										<h3>{ this.state.item.title }</h3>
										<p>{ this.state.item.date ? this.state.item.date.split(' ')[0] : "" }</p>
									</div>
									<div className="detailContent">
										{
											this.renderFeatured()
										}
										<p dangerouslySetInnerHTML={{ __html: this.state.item.desc }}></p>
									</div>
								</div>
							): ""
						}
					</div>

					{
						(this.state.item.reference) ? (
							<div className="referenceContainer sectionContainer">
								<div className="headline containerMaxWidth">
									<h2>References</h2>
								</div>
								<div className="bodyContent containerMaxWidth" dangerouslySetInnerHTML={{ __html: this.state.item.reference }} >
								</div>
							</div>
						) : ""
					}

				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(PostDetail));